import {MovementsDetailTyreModel} from './movements-detail-tyre.model';
import {Utilities} from '@shared/utilities/utilities.model';
import {TransferTypeEnum} from '../enum/transfer-type.enum';
import {TransferStatusEnum} from '../enum/transfer-status.enum';


export class MovementsDetailModel {

	cod_contract_type: string;
	cod_plate: string;
	cod_transfer_status: TransferStatusEnum;
	cod_transfer_type: TransferTypeEnum;
	cod_transport_po: string;
	custom_data: any;
	date_closed: Date;
	date_creation: Date;
	date_destination_delivery: Date;
	date_destination_outcome: Date;
	date_expected_delivery_availability: Date;
	date_expected_withdrawal_availability: Date;
	date_incomplete: Date;
	date_ok: Date;
	date_resolved: Date;
	date_source_outcome: Date;
	date_source_withdrawal: Date;
	date_transfer_accepted: Date;
	destination_outcome_reason: string;
	flag_destination_outcome: boolean;
	flag_forced_closure: boolean;
	flag_late: boolean;
	flag_ok: boolean;
	flag_source_outcome: boolean;
	flag_transport_documents: boolean;
	flag_valid: boolean;
	id_carrier: number;
	id_contract: number;
	id_customer: number;
	id_supplier_detail_destination: number;
	id_supplier_detail_source: number;
	id_transfer_order: number;
	source_outcome_reason: string;
	txt_carrier: string;
	txt_customer: string;
	txt_driver: string;
	txt_supplier_detail_destination: string;
	txt_supplier_detail_source: string;
	tyres: MovementsDetailTyreModel[];
	is_source: boolean;
	sale_info: SaleInfo;

	constructor(model?: any | MovementsDetailModel) {
		if (!Utilities.isVoid(model)) {
			this.cod_contract_type = model.cod_contract_type;
			this.cod_plate = model.cod_plate;
			this.cod_transfer_status = model.cod_transfer_status;
			this.cod_transfer_type = model.cod_transfer_type;
			this.cod_transport_po = model.cod_transport_po;
			this.custom_data = model.custom_data;
			this.date_closed = model.date_closed;
			this.date_creation = model.date_creation;
			this.date_destination_delivery = model.date_destination_delivery;
			this.date_destination_outcome = model.date_destination_outcome;
			this.date_expected_delivery_availability = model.date_expected_delivery_availability;
			this.date_expected_withdrawal_availability = model.date_expected_withdrawal_availability;
			this.date_incomplete = model.date_incomplete;
			this.date_ok = model.date_ok;
			this.date_resolved = model.date_resolved;
			this.date_source_outcome = model.date_source_outcome;
			this.date_source_withdrawal = model.date_source_withdrawal;
			this.date_transfer_accepted = model.date_transfer_accepted;
			this.destination_outcome_reason = model.destination_outcome_reason;
			this.flag_destination_outcome = model.flag_destination_outcome;
			this.flag_forced_closure = model.flag_forced_closure;
			this.flag_late = model.flag_late;
			this.flag_ok = model.flag_ok;
			this.flag_source_outcome = model.flag_source_outcome;
			this.flag_transport_documents = model.flag_transport_documents;
			this.flag_valid = model.flag_valid;
			this.id_carrier = model.id_carrier;
			this.id_contract = model.id_contract;
			this.id_customer = model.id_customer;
			this.id_supplier_detail_destination = model.id_supplier_detail_destination;
			this.id_supplier_detail_source = model.id_supplier_detail_source;
			this.id_transfer_order = model.id_transfer_order;
			this.source_outcome_reason = model.source_outcome_reason;
			this.txt_carrier = model.txt_carrier;
			this.txt_customer = model.txt_customer;
			this.txt_driver = model.txt_driver;
			this.txt_supplier_detail_destination = model.txt_supplier_detail_destination;
			this.txt_supplier_detail_source = model.txt_supplier_detail_source;
			this.is_source = model.is_source;
			this.sale_info = Utilities.isVoid(model.sale_info) ? null : new SaleInfo(model.sale_info);

			if (!Utilities.isVoid(model.tyres)) {
				this.tyres = model.tyres.map(t => new MovementsDetailTyreModel(t));
			}
		}
	}

}

export class SaleInfo {

	txt_sale_address: string;
	txt_sale_contact_name: string;
	txt_sale_contact_registry_information: string;
	txt_sale_mail: string;
	txt_sale_notes: string;
	txt_sale_phone_number: string;
	val_sale_price: number;

	constructor(model?: any | SaleInfo) {
		if (!Utilities.isVoid(model)) {
			this.txt_sale_address = model.txt_sale_address;
			this.txt_sale_contact_name = model.txt_sale_contact_name;
			this.txt_sale_contact_registry_information = model.txt_sale_contact_registry_information;
			this.txt_sale_mail = model.txt_sale_mail;
			this.txt_sale_notes = model.txt_sale_notes;
			this.txt_sale_phone_number = model.txt_sale_phone_number;
			this.val_sale_price = model.val_sale_price;
		}
	}

}
